module.exports = __webpack_public_path__ + "static/media/user-icon.94a93af2.svg";